module.exports = __webpack_public_path__ + "img/SKMJ_crain1.06252e18.jpg";